import { CpCellType, GeoTestMethod, RecommendationResult } from '.';
import { Status } from '../Status';

export interface ICreateGeoTestRequest {
  conversionTypeId: number;
  recommendationId: number;
  executionId: string;
  cellName: string;
  cellRank: number;
  testName: string;
  businessQuestion: string;
  startDate: string | null;
  endDate: string | null;
  reportStartDate: string;
  reportEndDate: string;
  executionMethod: GeoTestMethod;
  testType: CpCellType;
  scaleCost: number;
  status: Status;
  recommendationResult?: RecommendationResult | null;
  campaigns: ICampaignScale[];
  campaignSnapShot: ICampaignSnapShot[];
  geoScopeIds?: number[];
  multipleKpiDtl?: {
    multipleKpiIds: number[] | undefined;
    primaryKpiId: number | undefined;
  };
  kpiType: KPIType;
}

export enum KPIType {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE'
}

export interface ICampaignScale {
  campaignId: string | number;
  dtdCampaign: { campaignId: string | number; subCampaignId: string | number };
  adAccountId: string | number;
  scale: number;
  scaleType: string;
  geoDataSourceId: string;
  channel: string;
  segment: string;
  tactic: string;
  spend: number;
}

export interface ICampaignSnapShot {
  id: string;
  tactic: string;
  geoDataSourceId: string;
  validation: Record<string, string>;
}
